<template>
  <div id="app">
    <!-- 使用 transition 元素包裹路由出口 -->
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <audio preload autoplay loop id="music"></audio>
  </div>
</template>

<script>
import { getData } from '@/assets/device'
export default {
  name: 'App',
  data () {
    return {}
  },
  mounted () {
    getData()
    this.$applyHeights()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {}
}
</script>

<style scoped lang="less">
/* 定义fade过渡样式 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
